import { MessageFilters } from '@cigna/chcp/shared/util';

export const defaultMessageCenterFilters: MessageFilters = {
  read: [{ value: 'unread', label: 'Unread', isSelected: false }],
  flag: [{ value: 'flagged', label: 'Flagged', isSelected: false }],
  date: { range: 'all' },
  provider: '',
  claimStatus: '',
};
